import { Notify } from 'quasar'
import { transRoutes } from 'src/router/index'

export default ({ app, router, store, Vue }) => {
  router.beforeEach((to, from, next) => {
    store.dispatch('UserStore/checkLoginUserInfo').then((res) => {
      if (store.getters['UserStore/getUserIsLogin'] === true) {
        if (store.getters['UserStore/getLoginUserIsTermsAgreed'] !== true) {
          if (to.name !== 'terms') {
            return next({
              name: 'terms',
              query: {
                redirect: to.fullPath
              }
            })
          }
        }
      }

      if (to.meta && to.meta.requiredLogin === true) {
        if (store.getters['UserStore/getUserIsLogin'] !== true) {
          Notify.create({
            type: 'negative',
            message: '請先登入'
          })

          next({
            name: 'home',
            query: {
              action: 'login',
              redirect: to.fullPath
            }
          })
          return
        }
      }

      const dynamicRoutes = transRoutes(store.getters['UserStore/getRouterList'])
      let baseRoute = [
        {
          Visible: '0',
          path: '/dashboard',
          props: false,
          title: '一级菜单',
          component: () => import('layouts/Backend.vue'),
          icon: null,
          meta: null,
          children: [
            {
              path: '',
              name: 'backend_home',
              component: () => import('pages/Backend/Index.vue')
            },
            {
              path: 'user',
              component: {
                render: (h) => h('router-view')
              },
              children: [
                {
                  path: 'user/backend_user',
                  name: 'backend_user',
                  component: () => import('pages/Backend/User/User.vue'),
                  meta: {
                    requiredLogin: true
                  }
                }
              ]
            }
          ]
        }
      ]

      if (Array.isArray(dynamicRoutes)) {
        const routeExists = router.getRoutes().some((route) => route.path === '/dashboard')
        dynamicRoutes.forEach((route) => {
          if (!routeExists) {
            route.children.push(...baseRoute[0].children)
            router.addRoute(route)
            if (to.redirectedFrom) {
              next(to.redirectedFrom)
            } else {
              next({ ...to, replace: true });
            }
          }
        })
      }

      next()
    })
  })
}
